import { usePostMutation } from "../../../hooks/useClientPortalQuery";

import { SetupSCAModel } from "../../../types/generated/models";
import { useClientPortalConfigContext } from "../../../context/ClientPortalConfig.ctx";
import { AxiosError } from "axios";

export function useCreateOrUpdateCustomFormCustomerCreditCard(publicId: string) {
    const { clientPortalGuid } = useClientPortalConfigContext();
    const { mutateAsync } = usePostMutation<void, AxiosError, SetupSCAModel>({
        url: `/api/v1/${clientPortalGuid}/Stripe/CreateOrUpdateCustomFormCustomer?publicId=${publicId}`,
    });

    return {
        createOrUpdateCustomFormCustomerCreditCard: mutateAsync,
    };
}
